'use client';

import { LootBoxesBanner } from './LootBoxesBanner';
import { LootBoxesList } from './LootBoxesList';
import { LootBoxesSearch } from './LootBoxesSearch';
export const LootBoxes: React.FC = () => {
  return <>
      <LootBoxesBanner />
      <LootBoxesSearch />
      <LootBoxesList />
    </>;
};